import { defineComponent, computed } from 'vue-demi';
import { OrIconV3, useResponsive } from '@onereach/ui-components';
import { openBlock, createElementBlock, createElementVNode, toDisplayString, resolveComponent, normalizeClass, Fragment, renderList, createBlock, withCtx, createVNode, createCommentVNode } from 'vue';

const breadcrumbDefaultItem = ['flex', 'min-w-0', 'typography-caption-bold', 'text-outline', 'hover:text-on-background', 'dark:text-outline-dark', 'hover:dark:text-on-background-dark'];
const breadcrumbLastItem = ['flex', 'min-w-0', 'typography-caption-bold', 'cursor-default', 'pointer-events-none', 'text-on-background dark:text-on-background-dark'];

var script$1 = defineComponent({
  name: 'ServiceNavigationBreadcrumbLabel',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
});

const _hoisted_1 = {
  class: "container flex max-w-full"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("span", null, toDisplayString(_ctx.label), 1 /* TEXT */)]);
}

script$1.render = render$1;
script$1.__file = "src/components/ServiceNavigationBreadcrumbs/ServiceNavigationBreadcrumbLabel.vue";

var script = defineComponent({
  name: 'ServiceNavigationBreadcrumbs',
  components: {
    OrIcon: OrIconV3,
    ServiceNavigationBreadcrumbLabel: script$1
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const {
      isMobile
    } = useResponsive();
    const bgStyles = computed(() => {
      return isMobile.value ? ['bg-surface-1', 'dark:bg-surface-1-dark'] : ['bg-background', 'dark:bg-background-dark'];
    });
    return {
      breadcrumbDefaultItem,
      breadcrumbLastItem,
      bgStyles
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_service_navigation_breadcrumb_label = resolveComponent("service-navigation-breadcrumb-label");
  const _component_router_link = resolveComponent("router-link");
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["scrollbar-hidden flex max-w-full gap-md overflow-auto py-[6px] md:px-xl", _ctx.bgStyles]),
    "data-test": "breadcrumbs"
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (breadcrumb, index) => {
    return openBlock(), createElementBlock("div", {
      key: breadcrumb.label,
      class: "flex min-w-fit max-w-full items-center justify-center gap-md whitespace-nowrap",
      "data-test": "breadcrumb-item"
    }, [index !== _ctx.items.length - 1 ? (openBlock(), createBlock(_component_router_link, {
      key: 0,
      class: normalizeClass(_ctx.breadcrumbDefaultItem),
      to: breadcrumb.to
    }, {
      default: withCtx(() => [createVNode(_component_service_navigation_breadcrumb_label, {
        label: breadcrumb.label
      }, null, 8 /* PROPS */, ["label"])]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "to"])) : createCommentVNode("v-if", true), index !== _ctx.items.length - 1 ? (openBlock(), createBlock(_component_or_icon, {
      key: 1,
      class: "typography-caption-bold text-on-background dark:text-on-background-dark",
      icon: "chevron_right"
    })) : (openBlock(), createElementBlock("span", {
      key: 2,
      class: normalizeClass(_ctx.breadcrumbLastItem)
    }, [createVNode(_component_service_navigation_breadcrumb_label, {
      label: breadcrumb.label
    }, null, 8 /* PROPS */, ["label"])], 2 /* CLASS */))]);
  }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/ServiceNavigationBreadcrumbs/ServiceNavigationBreadcrumbs.vue";

export { script as s };
